export class OrderRoutes {
    constructor(basePath) {
        this.root = `${basePath}order`;
        this.summary = "summary";
        this.orderIdParam = ":orderId";
    }
    get basePath() {
        return `${this.root}/${this.orderIdParam}`;
    }
    get summaryPath() {
        return `${this.basePath}/${this.summary}`;
    }
    getSummaryUrl(orderId) {
        return `${this.root}/${orderId}/${this.summary}`;
    }
}
//# sourceMappingURL=OrderRoutes.js.map